export default "__VITE_ASSET__018400a8__"